import React from 'react';
import { cn } from '../../lib/cn';

export default function KbdShortcut({ className, children, ...rest }) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center min-w-[18px] h-[18px] px-1',
        'text-[10px] font-medium font-mono text-slate-500',
        'bg-white border border-slate-200 rounded shadow-soft',
        className
      )}
      {...rest}
    >
      {children}
    </kbd>
  );
}
